import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { FileSaverService } from 'ngx-filesaver';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor(private fileSaverService: FileSaverService) { }

  excel(columns, data, filename) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Data');

    worksheet.columns = columns.map((col) => ({
      header: col,
      key: col,
    }));
    worksheet.getColumn('H').numFmt = '#,##0.00';
    worksheet.getColumn('I').numFmt = '#,##0.00';
    worksheet.getColumn('J').numFmt = '#,##0.00';
    worksheet.getColumn('P').numFmt = '#,##0.00';

    worksheet.addRows(data);

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      this.fileSaverService.save(blob, filename);
    });
  }
}
